import { hello } from './components/plugins';
import framework from './pjax/framework';
import utils from './pjax/utils';

hello();

// handle all links
// const links = Array.from(document.querySelectorAll('a'));
//
// links.forEach((el) => {
//     el.onclick = utils.handleRoute;
// });

// start the magic!
framework.init();



/** WEBPACK FOOTER **
 ** ./app.js
 **/